export type SessionUser = {
  id?: string;
  name?: string | null;
  email?: string | null;
  image?: string | null;
};

export async function fetchSessionUser(): Promise<SessionUser | null> {
  try {
    const response = await fetch("/api/auth/session", { credentials: "include" });
    if (!response.ok) return null;
    const session = (await response.json()) as { user?: SessionUser } | null;
    return session?.user ?? null;
  } catch {
    return null;
  }
}

export function displayNameForUser(user: SessionUser): string {
  const name = user.name?.trim();
  if (name) return name;
  const email = user.email?.trim();
  if (email) return email.split("@")[0] ?? email;
  return "user";
}
